<template>
  <div class="cart-resume">
    <p class="cart-title">{{ Translator('front.cart.resume.title')}}</p>
    <div class="cart-resume-wrapper" :class="{'is-loading': !isReady}">
      <div v-if="cart && cart.items && cart.items.length > 0">
        <p class="cart-resume-subtitle">{{ Translator('front.cart.resume.processing.title') }}</p>
        <div class="cart-resume-processings" :class="{'is-loading': processings === null}" v-if="currentStep === 0">
          <label class="cart-radio" v-for="processing in processings" :key="processing.id" v-on="processing.enabled ? { touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } processingChoice = processing['@id']; onDebounceChange(); onScroll = false; }} : {}">
            <input type="radio" v-model="processingChoice" :value="processing['@id']" @change="onChange" :disabled="!processing.enabled">
            <div class="cart-radio-wrapper" :class="{'is-checked': processingChoice === processing['@id']}">
              <div class="cart-radio-content">
                <p class="cart-radio-title">{{ processing.name }}</p>
                <p class="cart-radio-detail" v-html="processing.shippingText"></p>
              </div>
              <div class="cart-radio-price">
                <p class="cart-radio-value" v-if="processing.priceTtc === 0">{{ Translator('front.cart.resume.processing.include') }}</p>
                <div v-else>
                  <p class="cart-radio-value" >
                    <template v-if="displayedHt">+{{ (processing.price/100) | toFixed(2) }} €<sup>{{ Translator('front.cart.price_ht') }}</sup></template>
                    <template v-else>+{{ (processing.priceTtc/100) | toFixed(2) }} €</template>
                  </p>
                  <p>{{ Translator('front.cart.resume.processing.per_card') }}</p>
                </div>
              </div>
            </div>
            <div class="cart-resume-disable" v-if="!processing.enabled">
              <p class="cart-resume-disable-title">{{ Translator('front.cart.resume.processing.disable_title') }}</p>
              <div class="cart-resume-disable-content" v-if="processing.unavailableText" v-html="processing.unavailableText"></div>
            </div>
          </label>
        </div>
        <div v-else>
          <div class="cart-resume-row" v-if="cart.processingType">
            <div class="cart-resume-group">
              <p class="cart-resume-label">{{ cart.processingType.name }}</p>
              <p class="cart-resume-complement" v-html="cart.processingType.shippingText"></p>
            </div>
            <div class="cart-resume-value">
              <p v-if="cart.processingType.priceTtc === 0">{{ Translator('front.cart.resume.processing.include') }}</p>
              <div v-else>
                <p>
                  <template v-if="displayedHt">+{{ (cart.processingType.price/100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
                  <template v-else>+{{ (cart.processingType.priceTtc/100) | toFixed(2) }} €</template>
                </p>
                <p>{{ Translator('front.cart.resume.processing.per_card') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cart-resume-container" v-if="isReady">
        <div class="cart-resume-items">
          <table v-if="cart && cart.items && cart.items.length > 0" :class="{'is-show': showDetail}">
            <thead>
              <tr>
                <td>{{ Translator('front.cart.resume.command.title') }} <template v-if="displayedHt">{{ Translator('front.cart.price_ht') }}</template><template v-else>{{ Translator('front.cart.price_ttc') }}</template></td>
                <td>{{ Translator('front.cart.resume.command.quantities', {'quantities': cart.items.length}) }}</td>
                <td>
                  <template v-if="displayedHt">{{ (cart.totalItemsPriceHt /100) | toFixed(2) }} €</template>
                  <template v-else>{{ (cart.totalItemsPriceTtc /100) | toFixed(2) }} €</template>
                </td>
              </tr>
              <tr class="table-action">
                <td colspan="2"><button type="button" @click="showDetail = !showDetail">{{ Translator('front.cart.resume.resume.details') }}</button></td>
                <td><button type="button" class="table-action-button" @click="showDetail = !showDetail">
                    <i class="ico ico-chevron-right-medium"></i>
                  </button>
                </td>
              </tr>
            </thead>
            <tbody v-if="showDetail">
              <tr v-for="item in cart.items" :key="item.id">
                <td v-if="item.cardOrderItem">{{ item.cardOrderItem.name }}</td>
                <td v-else>{{ item.variant.product.name }}</td>
                <td>{{ item.quantity ? item.quantity : '1' }}</td>
                <td>
                  <template v-if="displayedHt">{{ (item.undiscountedTotalHt /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
                  <template v-else>{{ (item.undiscountedTotalTtc /100) | toFixed(2) }} €</template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="cart-resume-container" v-if="cart && cart.items && cart.items.length > 0">
        <div class="cart-resume-row">
          <p class="cart-resume-label" v-if="currentStep >= 2">{{ Translator('front.cart.resume.resume.delivery') }} <template v-if="displayedHt">{{ Translator('front.cart.price_ht') }}</template><template v-else>{{ Translator('front.cart.price_ttc') }}</template></p>
          <p class="cart-resume-label" v-else>{{ Translator('front.cart.resume.resume.delivery_estimate') }} <template v-if="displayedHt">{{ Translator('front.cart.price_ht') }}</template><template v-else>{{ Translator('front.cart.price_ttc') }}</template></p>
          <p class="cart-resume-value" v-if="cart.shippingTotal === 0">{{ Translator('front.cart.delivery.free') }}</p>
          <p class="cart-resume-value" v-else>
            <template v-if="displayedHt">{{ (cart.shippingTotalHt /100) | toFixed(2) }} €</template>
            <template v-else>{{ (cart.shippingTotalTtc /100) | toFixed(2) }} €</template>
          </p>
        </div>
        <div class="cart-resume-row" v-if="cart.promotionCoupon">
          <p class="cart-resume-label">{{ cart.promotionCoupon.promotion.name }} &nbsp;
            <template v-if="displayedHt">{{ (cart.orderPromotionTotal /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ht') }}</sup></template>
            <template v-else>{{ (cart.orderPromotionTotalTtc /100) | toFixed(2) }} € <sup>{{ Translator('front.cart.price_ttc') }}</sup></template>
          </p>
          <p class="cart-resume-value">
            <button type="button" class="cart-resume-ico-button" @click="onRemovePromotion">
              <i class="ico ico-cross"></i>
              <span class="hide-access">{{ Translator('front.cart.promotion.remove') }}</span>
            </button>
          </p>
        </div>
        <div class="cart-resume-row">
          <p class="cart-resume-label">{{ Translator('front.cart.resume.resume.total') }} {{ Translator('front.cart.price_ht') }}</p>
          <p class="cart-resume-value">{{ (cart.totalHt /100) | toFixed(2) }} €</p>
        </div>
        <div class="cart-resume-row">
          <p class="cart-resume-label">{{ Translator('front.cart.resume.resume.vat') }}</p>
          <p class="cart-resume-value">{{ (cart.totalVat /100) | toFixed(2) }} €</p>
        </div>
        <div class="cart-resume-row cart-resume-row--big">
          <p class="cart-resume-label">{{ Translator('front.cart.resume.resume.total') }} {{ Translator('front.cart.price_ttc') }}</p>
          <p class="cart-resume-value">{{ (cart.totalTtc /100) | toFixed(2) }} €</p>
        </div>
      </div>
      <form class="cart-resume-promo" v-if="currentStep === 0 && cart && cart.items && cart.items.length > 0 && !cart.promotionCoupon" @submit="onSubmitPromo">
        <div class="cart-resume-promo-goup">
          <input class="cart-resume-promo-input" v-model="form.promoCode" type="text" :placeholder="Translator('front.cart.promotion.placeholder')">
          <button class="cart-resume-promo-button" type="submit" :disabled="isPromoSubmited" :class="{'is-loading': isPromoSubmited}">{{ Translator('front.cart.promotion.button') }}</button>
        </div>
        <p class="cart-resume-promo-error" v-if="errorPromo">{{ errorPromo }}</p>
      </form>
      <p class="cart-resume-error" v-if="cartError">{{ cartError }}</p>
      <button type="button" class="cart-resume-button" v-if="isReady" @click="goToNext" :disabled="isLimited || !cart || isLoading || (cart && cart.items && cart.items.length === 0)" :class="{'is-loading': isLoading && cart}">
        <span v-if="currentStep === 0">{{ Translator('front.cart.resume.buttons.step_1') }}</span>
        <span v-if="currentStep === 1">{{ Translator('front.cart.resume.buttons.step_2') }}</span>
        <span v-if="currentStep === 2">{{ Translator('front.cart.resume.buttons.step_3') }}</span>
        <span v-if="currentStep === 3">{{ Translator('front.cart.resume.buttons.step_4') }}</span>
      </button>
      <p class="cart-resume-limited" v-if="cart && isLimited" v-html="Translator('front.cart.resume.limited', {processName: cart.processingType.name, allowedCardsPerCustomer: cart.processingType.allowedCardsPerCustomer, })"></p>
    </div>
  </div>
</template>
<script>
import debounce from 'debounce';
import AppControlService from '@/services/AppControl';
import OrdersService from '@/services/Orders';
import UsersService from '@/services/Users';

export default {
  name: 'cart-resume',
  data () {
    return {
      showDetail: false,
      isLoading: false,
      isReady: false,
      cart: null,
      currentStep: AppControlService.currentStep,
      processings: null,
      errorPromo: null,
      cartError: null,
      isPromoSubmited: false,
      processingChoice: null,
      isInit: false,
      form: {
        promoCode: null
      }
    }
  },
  created() {
    this._onActiveLoading = this._onActiveLoading.bind(this);
    this._onDisableLoading = this._onDisableLoading.bind(this);
    this._onUpdateCart = this._onUpdateCart.bind(this);
    this._onUpdateStep = this._onUpdateStep.bind(this);
    this._onLogged = this._onLogged.bind(this);
    this._onCartChanged = this._onCartChanged.bind(this);
    AppControlService.on('updated', this._onDisableLoading);
    AppControlService.on('step', this._onUpdateStep);
    AppControlService.on('validating', this._onActiveLoading);
    AppControlService.on('aborted', this._onDisableLoading);
    OrdersService.on('updating', this._onActiveLoading);
    OrdersService.on('updated', this._onUpdateCart);
    OrdersService.on('cart-changed', this._onCartChanged);
    UsersService.on('update', this._onLogged);
  },

  beforeDestroy() {
    AppControlService.off('updated', this._onDisableLoading);
    AppControlService.off('step', this._onUpdateStep);
    AppControlService.off('validating', this._onActiveLoading);
    AppControlService.off('aborted', this._onDisableLoading);
    OrdersService.off('updating', this._onActiveLoading);
    OrdersService.off('updated', this._onUpdateCart);
    OrdersService.off('cart-changed', this._onCartChanged);
    UsersService.off('update', this._onLogged);
  },

  computed: {
    isLimited: function() {
      return !this.cart?.validCountItems;
    },
    displayedHt: function() {
      return this.cart?.displayedHt;
    }
  },

  mounted() {
    const isLogged = document.querySelector('[data-logged]').dataset.logged === 'true';
    if(!isLogged) this.isReady = true;
  },
  methods: {
    goToNext() {
      if(this.isLoading || !this.isReady) return;
      this.cartError = null;
      if(this.currentStep !== 0) {
        AppControlService.validStep();
        return;
      }
      // Confirming the cart: make sure what is displayed is still what will be ordered (the
      // processing type may have been closed, or the cart edited in another tab, meanwhile)
      const displayed = OrdersService.expected(this.cart);
      this._onActiveLoading();
      OrdersService.get().then( (cart) => {
        const current = OrdersService.expected(cart);
        const processingType = cart && cart.processingType;
        if(current.expectedTotal !== displayed.expectedTotal
          || current.expectedProcessingType !== displayed.expectedProcessingType
          || (processingType && !processingType.enabled)) {
          this._onCartChanged(this.Translator(processingType && !processingType.enabled ? 'front.cart.payment.processing_type_unavailable' : 'front.cart.payment.cart_changed'));
          this._onDisableLoading();
          return;
        }
        AppControlService.validStep();
      }).catch( () => {
        this._onDisableLoading();
      });
    },

    _onCartChanged(message) {
      this.cartError = message;
      this._getProcessings();
    },

    _onLogged() {
      this.isConnected = UsersService.isConnected;
      if(UsersService.isConnected) this.isReady = true;
    },

    _onActiveLoading() {
      this.isLoading = true;
    },

    _onDisableLoading() {
      this.isLoading = false;
    },

    onRemovePromotion() {
      this.form.promoCode = null;
      this.cart.promotions = null;
      this.isPromoSubmited = true;
      OrdersService.promoUpdate().then().then(() => {
        this.isPromoSubmited = false;
      })
    },

    onSubmitPromo(pEvt) {
      pEvt.preventDefault();
      if(this.isPromoSubmited) return;
      this.errorPromo = null;
      this.isPromoSubmited = true;
      OrdersService.promoUpdate(this.form.promoCode).then().catch(err => {
        this.errorPromo = err.response.data.message;
        setTimeout(() => {
          this.errorPromo = null;
        }, 2500);
      }).then(() => {
        this.isPromoSubmited = false;
        this.form.promoCode = null;
        this.isLoading = false;
      })
    },

    onChange() {
      this._onActiveLoading();
      this.onDebounceChange();
    },

    onDebounceChange: debounce( function() {
      if(this.processingChoice) {
        OrdersService.update({
          processingType: this.processingChoice
        }).then().then( () => {
          this._onDisableLoading();
        })
      }
    }, 1000),

    _getProcessings() {
      this.processings = null;
      OrdersService.getProcessings().then( res => {
        this.processings = res.data['hydra:member'];
        if(this.processings.length > 0) {
          for(let i = 0; i < this.processings.length; i++) {
            if(this.processingChoice === this.processings[i]['@id'] && !this.processings[i].enabled) {
              this.processingChoice = null;
              break;
            }
          }
          if(this.processingChoice === null) {
            for(let i = 0; i < this.processings.length; i++) {
              if(this.processings[i].enabled) {
                this.processingChoice = this.processings[i]['@id'];
                break;
              }
            }
            // The cart's processing type has been closed: save the fallback choice, otherwise the
            // radio shows it while the cart (total, payments) is still on the closed one
            if(this.processingChoice && this.cart && this.cart.processingType && this.cart.processingType['@id'] !== this.processingChoice) {
              this.onChange();
            }
          }
        }
      });
    },

    _onUpdateStep(step) {
      this.currentStep = step;
      setTimeout(() => {
        this._onDisableLoading();
      });
    },

    _onUpdateCart(res) {
      this.cart = res;
      if(this.cart && this.cart.processingType) this.processingChoice = this.cart.processingType['@id'];
      if(!this.processings) this._getProcessings();

      if(this.cart && !this.cart.processingType && !this.isInit) this.onChange();
      this._onDisableLoading();
      this.isInit = true;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss">
.cart-resume {
  width: 100%;
  align-self: flex-start;
  position: sticky;
  top: rem(100);
  table {
    width: 100%;
    tbody,
    thead {
      color: $black;
      font-size: rem(14);
    }
    td:first-child {
      max-width: rem(150);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    td:last-child {
      text-align: right;
    }
    &.is-show {
      .table-action {
        .ico {
          transform: rotate(-90deg);
        }
      }
    }
    .table-action {
      .ico {
        transform: rotate(90deg);
        transition: transform .2s;
      }
      .table-action-button {
        text-align: right;
        padding-left: rem(10);
        padding-right: rem(10);
      }
      td {
        padding-top: rem(10);
        font-weight: bold;
      }
      button {
        @include resetBtn;
        padding-top: rem(5);
        padding-bottom: rem(5);
        width: 100%;
        text-align: left;
        font-size: rem(14);
      }
    }
    tbody {
      td:nth-child(2) {
        text-align: center;
      }
    }
  }
  .cart-resume-wrapper {
    position: relative;
    min-height: rem(300);
    &.is-loading {
      @include loader;
    }
  }
  .cart-resume-items {}
  .cart-resume-container {
    margin-top: rem(20);
    padding-top: rem(20);
    border-top: rem(1) solid $grey-light;
  }
  .cart-resume-subtitle {
    color: $black;
    font-weight: bold;
    margin-bottom: rem(10);
  }
  .cart-resume-processings {
    position: relative;
    min-height: rem(80);
    &.is-loading {
      @include loader;
    }
  }
  .cart-resume-error {
    color: $color-error;
    font-size: rem(14);
    margin-bottom: rem(15);
  }
  .cart-resume-limited {
    color: $color-error;
    font-size: rem(12);
    margin-top: rem(20);
  }
  .cart-resume-disable {
    @include container;
    @include hidden;
    pointer-events: none;
    border-radius: rem(10);
    overflow: hidden;
    width: 80%;
    position: absolute;
    top: rem(4);
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    .cart-resume-disable-title {
      color: $white;
      background-color: $red-medium;
      padding: rem(10) rem(20);
      font-size: rem(12);
    }
    .cart-resume-disable-content {
      padding: rem(10) rem(20);
      &, p {
        font-size: rem(9);
      }
    }
  }
  .cart-resume-complement {
    color: $grey;
  }
  .cart-resume-row {
    display: flex;
    align-items: center;
    color: $black;
    font-size: rem(14);
    margin-bottom: rem(10);
    &.cart-resume-row--big {
      font-size: rem(18);
      font-weight: bold;
    }
  }
  .cart-resume-label {
    line-height: 1;
  }
  .cart-resume-sublabel {
    font-style: italic;
    font-size: rem(14);
  }
  .cart-resume-ico-button {
    @include resetBtn;
    width: rem(25);
    height: rem(25);
    color: $grey;
    font-size: rem(18);
    transition: color $transition-out-hover;
    &:hover, &:focus {
      color: $color-second;
      transition: color $transition-in-hover;
    }
  }
  .cart-resume-promo {
    .cart-resume-promo-goup {
      display: flex;
      border: rem(1) solid $grey;
      background-color: $white;
      padding: rem(2);
      border-radius: rem(10);
    }
    .cart-resume-promo-input {
      background: transparent;
      border: 0;
      width: 100%;
      padding: rem(7) rem(15);
      border-radius: rem(8) 0 0 rem(8);
    }
    .cart-resume-promo-button {
      @include cta($white, $color-second);
      border-radius: 0 rem(8) rem(8) 0;
    }
    .cart-resume-promo-error {
      @include form-error;
      @include visible;
      display: block;
    }
  }
  .cart-resume-value {
    margin-right: 0;
    margin-left: auto;
  }
  .cart-resume-button {
    @include cta;
    width: 100%;
    margin-top: rem(20);
  }
}
</style>
